export const ExpandUpIcon = ({ ...props }: React.SVGProps<SVGSVGElement>) => (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
        <path d='M20 16L12 8L4 16' stroke='currentColor' strokeWidth='2' />
    </svg>
);
